var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#ff4b05"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M362 81.6c-15.8-8.3-35.3-2.2-43.6 13.6s-2.2 35.3 13.6 43.6c53.9 28.2 87.7 84.1 87.6 144.9 0 90.2-73.4 163.6-163.6 163.6S92.4 374 92.4 283.8c-.1-60.9 33.7-116.7 87.6-144.9 15.8-8.3 21.9-27.8 13.6-43.6s-27.8-22-43.6-13.7C38.4 140.2-4.7 278.2 53.9 389.8s196.5 154.6 308.1 96 154.6-196.5 96.1-308.1c-21.5-41-55-74.5-96.1-96.1z",
    fill: "#ff4b05",
    opacity: 1,
    "data-original": "#ff4b05",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 254.5c17.8 0 32.3-14.5 32.3-32.3V32.3C288.3 14.5 273.8 0 256 0s-32.3 14.5-32.3 32.3v189.9c0 17.8 14.4 32.3 32.3 32.3z",
    fill: "#ff4b05",
    opacity: 1,
    "data-original": "#ff4b05",
    className: ""
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.7c7c79a65703c6420488c608b7415d6a.svg";
export { ForwardRef as ReactComponent };